import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _templateObject;

var _excluded = ["onResolve", "okText", "cancelText", "onOk", "onCancel", "okButtonProps", "cancelButtonProps", "okType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useState } from 'react';
import { Modal } from 'antd';
import styled from '@xstyled/styled-components';
import { styleVariables } from '../../style';
import { SecondaryButton, PrimaryButton } from '../button';
import { Space } from 'antd';
import { unmountComponentAtNode, render } from 'react-dom';
import { getSize } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ConfirmModal = function ConfirmModal(_ref) {
  var onResolve = _ref.onResolve,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? 'OK' : _ref$okText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      onOk = _ref.onOk,
      onCancel = _ref.onCancel,
      okButtonProps = _ref.okButtonProps,
      cancelButtonProps = _ref.cancelButtonProps,
      okType = _ref.okType,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(true),
      open = _useState[0],
      setOpen = _useState[1];

  var handleOk = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!onOk) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return onOk();

            case 3:
              setOpen(false);
              onResolve(true);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOk() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleCancel = function handleCancel() {
    if (onCancel) {
      onCancel();
    }

    setOpen(false);
    onResolve(false);
  };

  return /*#__PURE__*/_jsx(StyledModal, _objectSpread(_objectSpread({}, restProps), {}, {
    open: open,
    onOk: handleOk,
    onCancel: handleCancel,
    okButtonProps: {
      style: {
        display: 'none'
      }
    },
    cancelButtonProps: {
      style: {
        display: 'none'
      }
    },
    footer: /*#__PURE__*/_jsxs(Space, {
      size: 12,
      children: [/*#__PURE__*/_jsx(SecondaryButton, _objectSpread(_objectSpread({}, cancelButtonProps), {}, {
        onClick: handleCancel,
        children: cancelText
      })), /*#__PURE__*/_jsx(PrimaryButton, _objectSpread(_objectSpread({}, okButtonProps), {}, {
        onClick: handleOk,
        children: okText
      }))]
    })
  }));
};

var StyledModal = styled(Modal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-height: 90%;\n  max-width: 90%;\n  overflow-y: auto;\n\n  .ant-modal-content {\n    border-radius: 16px;\n    padding: 4px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n  }\n\n  .ant-modal-header {\n    border-bottom: none;\n    background: ", ";\n    padding: 16px 20px 6px;\n    border-radius: 16px 16px 0 0;\n  }\n\n  .ant-modal-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: ", ";\n    line-height: 1.4;\n  }\n\n  .ant-modal-footer {\n    border-top: none;\n    background: ", ";\n    padding: 6px 20px 16px;\n    border-radius: 0 0 16px 16px;\n    display: flex;\n    justify-content: flex-end;\n\n    .ant-space {\n      width: 100%;\n      justify-content: flex-end;\n    }\n\n    button {\n      height: 40px !important;\n      border-radius: 8px !important;\n      font-weight: 600 !important;\n      font-size: 14px !important;\n      padding: 0 20px !important;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      transition: all 0.2s;\n    }\n  }\n\n  /* Override SecondaryButton to be neutral like in the image */\n  /* Exclude .ant-switch: Switch is a <button> and would lose track/handle colors. */\n  .ant-btn-default,\n  button:not(.ant-btn-primary):not(.ant-switch) {\n    border: 1px solid ", " !important;\n    background: ", " !important;\n    color: ", " !important;\n\n    &:hover {\n      background: ", " !important;\n      border-color: ", " !important;\n      color: ", " !important;\n    }\n  }\n\n  /* Both buttons have borders */\n  .ant-btn {\n    border: 1px solid ", " !important;\n  }\n\n  .ant-btn-primary {\n    background: ", " !important;\n    border-color: ", " !important;\n    color: #ffffff !important;\n\n    &:hover {\n      background: ", " !important;\n      border-color: ", " !important;\n    }\n\n    &.ant-btn-dangerous,\n    &.ant-btn-danger {\n      background: ", " !important;\n      border-color: ", " !important;\n      color: #ffffff !important;\n\n      &:hover {\n        background: ", " !important;\n        border-color: ", " !important;\n        color: #ffffff !important;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    padding: ", " ", ";\n    font-size: 16px;\n    color: ", ";\n    line-height: 1.5;\n  }\n\n  .ant-modal-close {\n    top: 12px;\n    right: 12px;\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n\n  .ant-modal-close-x {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n  }\n"])), styleVariables.colors.gray1, styleVariables.colors.grey100, styleVariables.colors.gray1, styleVariables.colors.grey14, styleVariables.colors.gray1, styleVariables.colors.grey100, styleVariables.colors.gray2, styleVariables.colors.grey14, styleVariables.colors.blue3, styleVariables.colors.grey14, styleVariables.colors.blue3, styleVariables.colors.blue3, styleVariables.colors.blue2, styleVariables.colors.blue2, styleVariables.colors.colorErrorBase, styleVariables.colors.colorErrorBase, styleVariables.colors.colorErrorActive, styleVariables.colors.colorErrorActive, getSize('padding8'), getSize('padding24'), styleVariables.colors.gray11, styleVariables.colors.grey70, styleVariables.colors.grey100);
export var confirm = function confirm(props) {
  var div = document.createElement('div');
  document.body.appendChild(div);
  var currentProps = props;

  var onResolve = function onResolve(result) {
    setTimeout(function () {
      unmountComponentAtNode(div);
      div.remove();
    }, 0);
  };

  var renderModal = function renderModal() {
    render( /*#__PURE__*/_jsx(ConfirmModal, _objectSpread(_objectSpread({}, currentProps), {}, {
      onResolve: onResolve
    })), div);
  };

  renderModal();
  return {
    destroy: function destroy() {
      unmountComponentAtNode(div);
      div.remove();
    },
    update: function update(newConfig) {
      currentProps = _objectSpread(_objectSpread({}, currentProps), newConfig);
      renderModal();
    }
  };
};